export enum ApprovalState {
  APPROVED = "APPROVED",
  DISAPPROVED = "DISAPPROVED",
  PENDING = "PENDING",
}
